<template>
  <component :is="layout">
    <router-view/>
  </component>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { State } from 'vuex-class'

const DefaultLayout = () => import(/* webpackChunkName: "default-layout" */ './layouts/Default')
const IframeLayout = () => import(/* webpackChunkName: "iframe-layout" */ './layouts/Iframe')

@Component({
  components: {
    DefaultLayout,
    IframeLayout
  }
})
export default class App extends Vue {
  @State(state => state.CONTENT.iframe) iframe

  get layout () {
    if (this.iframe) {
      return 'iframe-layout'
    }
    return `${(this.$route.meta.layout || 'default')}-layout`
  }
}
</script>
<style lang="scss">
@import "@/style/_init.scss";

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

html, body {
  background-color: transparent;
  font-family: var(--app-font-family);
}

:root {
  --app-type-color: #{$dark};
  --app-font-family: #{$family-primary};
}

button {
  box-shadow: $box-shadow;
  &.is-app-type {
    @include is-app-type;
  }
}
</style>
